export const objectHasValues = (object: object) => {
	return Object.values(object).some(value => !!value);
};

export const clearObject = <T>(object: object) => {
	for (const key of Object.keys(object)) {
		const value = object[key as keyof object];
		if (!value) {
			delete object[key as keyof object];
		}
	}
	return object as T;
};